export var IOExtensionType;
(function (IOExtensionType) {
    IOExtensionType["ConnectESP"] = "ConnectESP";
    IOExtensionType["Smart2Pro"] = "Smart2Pro";
    IOExtensionType["H1PRO"] = "H1PRO";
    IOExtensionType["H2000PlusPro1"] = "H2000PlusPro1";
    IOExtensionType["H2000PlusPro2"] = "H2000PlusPro2";
    IOExtensionType["H1000PlusPro"] = "H1000PlusPro";
    IOExtensionType["H1000Pro722"] = "H1000Pro722";
    IOExtensionType["H2000ProV2_1"] = "H2000ProV2_1";
    IOExtensionType["H2000ProV2_2"] = "H2000ProV2_2";
    IOExtensionType["H1500PlusPro"] = "H1500PlusPro";
    IOExtensionType["H700PlusPro"] = "H700PlusPro";
    IOExtensionType["H1V02ProEbus"] = "H1V02ProEbus";
    IOExtensionType["H1V"] = "H1V";
    IOExtensionType["Smart"] = "Smart";
    IOExtensionType["ClimaticPro"] = "ClimaticPro";
    IOExtensionType["Lemax"] = "Lemax";
    IOExtensionType["Sockets_03"] = "Sockets_03";
    IOExtensionType["Sockets_03_THERMOSTAT"] = "Sockets_03_THERMOSTAT";
    IOExtensionType["Valtec_K500"] = "Valtec_K500";
})(IOExtensionType || (IOExtensionType = {}));
